var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-1 flex-col"},[_c('sub-header',{attrs:{"buttonText":"Create Order","showBtn":_vm.orderPermission,"handleClick":_vm.createOrder}}),_c('common-detail-table',{attrs:{"columns-props":_vm.columns,"show-row-link":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }